import React from 'react';
import { message } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import * as actions from 'store/actions';
import BN from 'bn.js';
import './style.css';

export default function Claim() {
  const dispatch = useDispatch();
  const token = process.env.REACT_APP_TOKEN_ADDRESS;
  const address = useSelector(state => state.address);
  const tranche = useSelector(state => state.tranche);
  const airdrop = useSelector(state => state.airdrop);

  const tranches = useSelector(state => state.tranches);
  const proofs = useSelector(state => state.proofs);
  const balances = useSelector(state => state.balances);
  const claimableAmount = useSelector(state => state.claimableAmount);

  const claim = async () => {
    try {
      if (!address) {
        message.error('Please connect wallet first. Ensure it matches the one used in the CyberFM App');
        return;
      }
      if (claimableAmount === 0) {
        message.error('You have nothing to claim. Pending becomes available on the 1st of each month.');
        return;
      }

      dispatch(actions.setLoading(true));
      const result = await airdrop.methods
        .multiClaim(address, tranches, balances, proofs)
        .send({ from: address }); 
      if (result.status) {
        message.success('Receive earnings successfully');
        dispatch(actions.setClaimableAmount(0));
      }
      dispatch(actions.setLoading(false));
    } catch (err) {
      dispatch(actions.setLoading(false));
      if (err.code === 4001) {
        return;
      }
      message.error('Claim has failed');
    }
  };

  return (
    <div>
    <a  className='btn-icon wow fadeIn' href='#' onClick={() => claim()}>
      <strong  >Claim Earned Tokens - CYFM</strong>
    </a>
    <br/><br/>

<audio autoPlay>
  <source src="https://play.adtonos.com/xtreme" type="audio/ogg" />
  <source src="https://play.adtonos.com/xtreme" type="audio/wav" />
  <source src="https://play.adtonos.com/xtreme" type="audio/mpeg" />
</audio>


    <ol className='add-token'>
    <li>
        <strong>READ BELOW - Important</strong><strong></strong>
        <br/><br/> </li>
      <li>
         Ethereum Network Requires <strong>GAS</strong> for transactions:<strong> We don't control GAS fees.</strong>
        <br/><br/> </li>
        <li>
        If you choose to <strong>CLAIM</strong> later your tokens will be waiting for you.<strong></strong>
        <br/><br/> </li>
        <li>
        <strong>BUY ETH for Gas: </strong> <a href="https://go.coinmama.com/visit/?bta=58785&nci=5343" target= "_blank">HERE</a><strong> --We are not affilated--</strong>
        <br/><br/> </li>
        <li>
        <strong></strong> <a href="https://youtu.be/hni077ton9M" target= "_blank"><strong>How To Video</strong></a><strong></strong>
        <br/><br/> </li>
        <li>
        Open MetaMask, in <strong>Assets</strong> tab, click <strong>Add Token</strong>
        <br/><br/> </li>
      <li>
        Choose <strong>Custom Token</strong>
        <br/><br/> </li>
      <li>Fill Token address CYFM-ERC20: {token}</li>
    </ol>
    
  </div>
  );
}
